import { Link } from "react-router-dom";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({
    title: "Off the map — Manitoba Security Services",
    description:
      "The page you requested is not part of our coverage. Return to the index and select from the operating catalog.",
    keywords: "404, page not found, Manitoba Security Services",
  });

  // Inject a noindex robots meta so search engines don't index the 404.
  if (typeof window !== "undefined") {
    let m = document.head.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    m.setAttribute("content", "noindex, follow");
  }

  return (
    <div
      data-testid="not-found"
      className="min-h-screen bg-[#050505] flex flex-col items-center justify-center px-6"
    >
      <p className="font-editorial italic text-[#FF3B30] text-lg">404</p>
      <h1 className="mt-4 font-display font-black uppercase tracking-tightest text-white text-6xl md:text-8xl leading-none text-center">
        Off the map.
      </h1>
      <p className="mt-6 font-body text-base text-[#a0a0a0] text-center max-w-md">
        The page you requested is not part of our coverage. Return to the
        index and select from the operating catalog.
      </p>
      <Link
        to="/"
        className="mt-10 font-display uppercase tracking-[0.18em] text-sm text-white border border-white/20 hover:border-[#FF3B30] px-8 py-4 transition-colors"
      >
        Return to Index
      </Link>
    </div>
  );
}
